export const SIGNIN = "/";
export const ADMIN_SIGNIN = "/admin-sign-in";
// export const SIGNIN_FORNECEDOR = '/signin-fornecedor';
export const SIGNUP_CANAL = "/signup-canal";
export const SIGNUP_FORNECEDOR = "/signup-fornecedor";
export const FORGOTPASSWORD = "/forgot-password";
export const RESETPASSWORD = "/reset-password/:token";
export const ACTIVEUSER = "/active-user/:token";

export const DASHBOARD_CANAL = "/dashboard-canal";
export const CANAL_EDIT_PROFILE = "/canal-edit-profile";
export const CANAL_SEARCH_FORNECEDORES = "/canal-search-fornecedores";
export const CANAL_FAVORITES = "/canal-favorites";
export const CANAL_SETTINGS = "/canal-settings";
export const CANAL_BUY_PREMIUM = "/canal-buy-premium";
export const CANAL_FAVORITES_PREMIUM = "/canal-favorites-premium";
export const CANAL_MY_FITS = "/canal-my-fits";

export const DASHBOARD_FORNECEDOR = "/dashboard-maquinas";
export const DASHBOARD_FORNECEDOR_PREMIUM = "/dashboard-maquinas-premium";
export const MINHAS_MAQUINAS_PREMIUM = "/minhas-maquinas-premium";
export const RELATORIOS_PREMIUM = "/relatorios-premium";
export const FINANCEIRO_PREMIUM = "/financeiro-premium";
export const PROMOCOES_PREMIUM = "/promocoes-premium";
export const ALERTAS_PREMIUM = "/alertas-premium";
export const ESTRATEGIAS_PREMIUM = "/estrategias-premium";
export const PELUCIAS_PREMIUM = "/pelucias-premium";
export const LOCALIZACOES_PREMIUM = "/localizacoes-premium";
export const CONFIGURACOES_PREMIUM = "/configuracoes-premium";
export const FORNECEDOR_EDIT_PROFILE = "/fornecedor-edit-profile";
export const FORNECEDOR_SEARCH_CANAIS = "/pagamentos";
export const EDIT_FORNECEDOR_CANAIS = "/edit-pagamento";
export const DELETE_FORNECEDOR_CANAIS = "/delete-pagamentos";
export const DELETE_FORNECEDOR = "/delete-maquina";
export const FORNECEDOR_FAVORITES = "/fornecedor-favorites";
export const FORNECEDOR_SETTINGS = "/fornecedor-settings";
export const FORNECEDOR_BUY_PREMIUM = "/fornecedor-buy-premium";
export const FORNECEDOR_NOTI = "/fornecedor-notifications";
export const FORNECEDOR_MY_FITS = "/my-fits";
export const FORNECEDOR_FAVORITES_PREMIUM = "/fornecedor-favorites-premium";
// export const MAIN = '/';

export const ADD_MACHINE = "/adicionar-maquina";
// export const EDIT_MACHINE = '/adicionar-maquina'

export const REMOTE_CREDIT = "/credito-remoto/:id";
export const HELP_PAGE = "/help-page-store_id";
export const TOKEN_HELP_PAGE = "/token-help-page";

export const LISTA_MAQUINAS = "/lista-maquinas";
export const CLIENTE_MENSALIDADES = "/minhas-mensalidades";
export const NEW_PASSWORD = "/resetar-senha";
export const DASHBOARD_CLIENTES = "/dashboard-clientes";
export const DELETE_CLIENTE = "/delete-cliente";
export const CLIENTES_MAQUINAS = "/cliente-maquinas";
export const EDITAR_CLIENTES = "/editar-cliente";
export const ADD_CLIENTES = "/novo-cliente";
export const CLIENTES_MAQUINAS_FORNECEDOR_SEARCH =
  "/cliente-maquinas/pagamentos";
export const CLIENTE_MENSALIDADES_ADM =
  "/cliente-maquinas/mensalidades";
export const MENSALIDADES_ADM_LIST =
"/clientes/mensalidades";
export const CLIENTES_MAQUINAS_EDIT_FORNECEDOR =
  "/cliente-maquinas/edit-pagamento-adm";
export const CLIENTES_MAQUINAS_DELETE_FORNECEDOR =
  "/cliente-maquinas/delete-pagamentos-adm";
export const CLIENTES_MAQUINA_DELETE_PAGAMENTOS =
  "/cliente-maquinas/delete-all-pagamentos-adm";
export const CLIENTES_MAQUINAS_TROCAR = "/cliente-maquinas/trocar";

export const ADD_CLIENTES_MAQUINA_ADM =
  "/cliente-maquinas/adicionar-maquina-adm";
export const CREDITO_REMOTO_ADM = "/cliente-maquinas/credito-remoto-adm";

export const RELATORIO = "/relatorio";
export const RELATORIO_ADMIN = "/cliente-maquinas/pagamentos/relatorio-adm";
export const RELATORIO_DISP = "/cliente-maquinas/disponibilidade/relatorio";
export const RELATORIO_DISP_ADMIN = "/cliente-maquinas/disponibilidade/relatorio-adm";
export const CONFIG = "/config";
export const CLIENTE_PAGAMENTOS = "/cliente-pagamentos";
// Auditoria
export const AUDITORIA =
"/auditoria";
export const DETALHE_AUDITORIA =
"/detalhe-auditoria";
